import {Component, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {MenuItem} from "primeng/api";
import {ContractPersonDto} from "../../../model/dto/entity/contract-person.dto";
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {WidgetToolbarCallbackInterface} from "../../../../../core/shared/widget/widget-toolbar-callback.interface";
import {MvsFormControlOverwrite} from "../../../../../core/shared/logic/form/logic/mvs-form-control-overwrite";
import {MvsFormFieldAccessEnum} from "../../../../../core/shared/logic/form/logic/mvs-form-field-access.enum";

@Component({
    selector: 'ci-contract-person',
    templateUrl: './ci-contract-person.component.html',
    standalone: false
})
export class CiContractPersonComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    tabItems: MenuItem[];
    activeItem: MenuItem | undefined;
    tabIndex: string = 'ci.ContractPerson';
    widgetContractPerson: WidgetData;
    widgetPerson: WidgetData;

    dto: ContractPersonDto;

    ngOnInit() {
        super.ngOnInit();

        this.tabItems = [
            {id: "ci.ContractPerson", label: "Zuweisung", icon: "fa-light fa-link"},
            {id: "pm.Person", label: "Person", icon: "fa-sharp fa-light fa-folder-user"},
        ];
        this.activeItem = this.tabItems[0];

    }

    onActiveItemChange(event: string | number) {
        this.activeItem = this.tabItems.find(item => item.id === event);
        this.tabIndex = event as string;
    }

    /**
     * On Object Change.
     */
    onObjectChanged() {

        this.widgetContractPerson = WidgetFactory.createWidgetObjectWithCallback(
            "ci.contract.person.assignment.form",
            "Vertragszuweisung",
            "ci.ContractPerson",
            {
                onFunctionObjectUpdate(widgetData: WidgetData): WidgetToolbarCallbackInterface {
                    const overwrite = new MvsFormControlOverwrite();
                    overwrite.addField("personDtoId", MvsFormFieldAccessEnum.HIDDEN);
                    overwrite.addField("contractDtoId", MvsFormFieldAccessEnum.HIDDEN);
                    return {formControlOverwrite: overwrite};
                }
            },
            this.dto.id
        );

        this.widgetPerson = WidgetFactory.createWidgetObject(
            "ci.contract.person.assigned.person.form",
            "Person",
            "pm.Person",
            this.dto.personDtoId
        );

    }

}
